import React from 'react';
import '../ImageSelection.css';
interface VideoSelectionProps {
  heading: string;
  subtitle: string; // Opcional, puede no estar presente
  description: string; // Opcional, puede no estar presente
}

const VideoSelection: React.FC<VideoSelectionProps> = ({ heading, subtitle, description }) => {
  return (
    <div className="image-selection-container">
      <div className="image-selection-header">
        <div className='heading'>{heading}</div>
        <div className='subtitle'>{subtitle}</div> {/* Subtítulo */}
        <div className='description'>Vídeo</div> {/* Descripción */}
      </div>
    </div>
  );
};

export default VideoSelection;
